import { Component, OnInit } from "@angular/core";
import { PhonePe } from "phonepesdk-web";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CommonHttpService } from "../commonHttp.service";
import { LoaderService } from "../../_shared/services/loader.service";
import { AddToCartService } from "../../_shared/services/add-to-cart.service";
import "rxjs/add/operator/filter";
import jsSHA from "jssha";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { async } from "@angular/core/testing";
declare var $: any;
//PhonePe.PhonePe.loggingEnabled = true
@Component({
  selector: "app-cart",
  templateUrl: "./cart.component.html",
  styleUrls: ["./cart.component.css"],
})
export class CartComponent implements OnInit {
  showLoaderProduct: boolean = false;
  userDetails: any = {};
  cartCopy: any = []
  utm_source: string;
  baseUrl: any = environment.apiUrl;
  imageUrl: any = environment.imageUrl;
  cartItems: any = [];
  cart: any = {};
  encodedBase64: any;
  EcartGrandTotal: number = 0;
  EcartTotal: number = 0;
  EcartTotalTaxAmount: number = 0;
  EcartTotalCessAmount: number = 0;
  EcartTotalDiscount: number = 0;
  quantityError: boolean = false;
  ppavl: boolean = false;
  availableQuantity: number;
  outOfStockError: boolean = false;
  customerId: any;
  zeroQuantityError: boolean = false;
  down: boolean = false;
  message: string = "";
  response: any = {};
  responseUserDetails: any = {};
  products: any = [];
  topSellingStock: any = [];
  products1: any = [];
  products2: any = [];
  showErrorForSamsung: any = false
  constructor(
    private service: CommonHttpService,
    private addToCartService: AddToCartService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private http: HttpClient
  ) {
    this.addToCartService.isCartChanged.subscribe((flag) => {
      this.cart = JSON.parse(localStorage.getItem("cart"));
      this.cartItems = this.cart != null ? this.cart.EcartItem : [];
      this.updateCart();
      console.log(this.cartItems);
      if (this.cart != null) {
        this.checkOutOfStockItems();
        this.CalculateTotals();
      }
    });
  }
  ngAfterViewInit() { }
  ngOnInit() {
    setTimeout(() => {
      if (window.screen.width > 480) {
        $("#topselling").owlCarousel({
          autoPlay: 2000, //Set AutoPlay to 2 seconds
          navigation: true,
          items: 5,
          itemsDesktop: [1199, 3],
          itemsDesktopSmall: [979, 3],
          responsive: true,
        });
      }
      else {
        $("#topselling").owlCarousel({
          autoPlay: 2000, //Set AutoPlay to 2 seconds
          navigation: false,
          items: 5,
          itemsDesktop: [1199, 3],
          itemsDesktopSmall: [979, 3],
          responsive: true,
        });
      }
    }, 2000);

    this.loadDataTopSelling();
    let IsPhonepe = JSON.parse(localStorage.getItem("utm_sources"));
    console.log(IsPhonepe);
    if (IsPhonepe == "phonepe") {
      this.ppavl = true;
      console.log(this.ppavl);
    }
    window.scrollTo(0, 0);
    this.customerId = Number(localStorage.getItem("customerId"));
    if (localStorage.getItem("isLoggedin")) {
      this.loaderService.display(true);
      this.service
        .get(this.baseUrl + "CartAPI/GetByUserId/" + this.customerId)
        .subscribe(
          (data) => {
            console.log(data);
            if (data.length != 0) {
              this.cartItems = data != null ? data[0].ecartList : [];
              this.cartCopy = data
            } else {
              this.cartItems = [];
              this.cartCopy = data
            }
            this.cart = {};
            this.cart.EcartItem = [];



            for (var i = 0; i < this.cartItems.length; i++) {
              this.cart.EcartItem.push({
                EcartItemId: 0,
                EcartMasterId: 0,
                ProductId: this.cartItems[i].productId,
                BatchId: this.cartItems[i].batchId,
                Quantity: this.cartItems[i].quantity,
                TaxAmount: this.cartItems[i].taxRates,
                CessTaxRate: this.cartItems[i].cessTaxRates,
                Mrp: this.cartItems[i].mrp,
                Price: this.cartItems[i].price,
                SubTotal: this.cartItems[i].price * this.cartItems[i].quantity,
                ProductImage: this.cartItems[i].imageUrl,
                ProductName: this.cartItems[i].productName,
                MaxStockLimit: this.cartItems[i].totalStock,
                CategoryId: this.cartItems[i].categoryId
              });
            }
            localStorage.setItem("cart", JSON.stringify(this.cart));
            console.log(this.cart);
            this.getCartItems();
            this.loaderService.display(false);
          },
          (error) => {
            console.log(error);
            this.loaderService.display(false);
          }
        );
    } else {
      this.cart = JSON.parse(localStorage.getItem("cart"));
      this.getCartItems();
    }
    this.siteDown();
  }
  siteDown = function () {
    this.service
      .get(this.baseUrl + "ErrorStatusAPI/GetCheckoutPageErrorStatus/")
      .subscribe(
        (data) => {
          console.log(data);
          var statusForDown = data;
          console.log(statusForDown.length);
          for (let i = 0; i < statusForDown.length; i++) {
            if (statusForDown[i].id == 4) {
              this.down = statusForDown[i].status;
              this.message = statusForDown[i].message;
            }
          }
        },
        (error) => { }
      );
  };
  getCartItems() {
    this.cartItems = this.cart != null ? this.cart.EcartItem : [];
    if (this.cart != null) {
      this.checkOutOfStockItems();
      this.CalculateTotals();
    }
    console.log("a");
    console.log(this.cartItems);
  }

  checkOutOfStockItems() {
    let flag = false;
    for (let i = 0; i < this.cartItems.length; i++) {
      if (this.cartItems[i].Quantity == 0) {
        flag = true;
      }
    }
    this.zeroQuantityError = flag;
    for (let i = 0; i < this.cartItems.length; i++) {
      if (this.cartItems[i].MaxStockLimit < this.cartItems[i].Quantity) {
        this.cartItems[i].outOfStock = true;
        this.outOfStockError = true;
        console.log("che kk errror out of stock");
        this.cartItems[i].Quantity = 0;
      } else {
        this.cartItems[i].outOfStock = false;
        this.outOfStockError = false;
      }
    }
  }
  async checkIfContainSamsung() {

    this.showErrorForSamsung = false
    // await console.log(this.cartItems)
    console.log(this.cartItems)


    for (var i = 0; i < this.cartItems.length; i++) {
      if (this.cartItems[i].CategoryId == environment.samsungCategoryId && this.ppavl == true) {
        this.showErrorForSamsung = true
      }
    }
    console.log(this.showErrorForSamsung)

    if (this.showErrorForSamsung == true) {
      await $('#asdf').click();
    }
    else {
      this.CheckOut()
    }

  }
  CalculateTotals() {
    this.EcartTotal = 0;
    this.EcartGrandTotal = 0;
    this.EcartTotalDiscount = 0;
    this.EcartTotalTaxAmount = 0;
    this.EcartTotalCessAmount = 0;
    for (var i = 0; i < this.cartItems.length; i++) {
      this.EcartTotal =
        this.EcartTotal + this.cartItems[i].Mrp * this.cartItems[i].Quantity;
      this.EcartGrandTotal =
        this.EcartGrandTotal +
        this.cartItems[i].Price * this.cartItems[i].Quantity;
      this.EcartTotalDiscount =
        this.EcartTotalDiscount +
        (this.cartItems[i].Mrp - this.cartItems[i].Price) *
        this.cartItems[i].Quantity;
    }
    this.EcartGrandTotal = Math.round(this.EcartGrandTotal);
    this.EcartTotalTaxAmount = Math.round(this.EcartTotalTaxAmount);
    this.EcartTotalDiscount = Math.round(this.EcartTotalDiscount);
    this.cart.EcartGrandTotal = this.EcartGrandTotal;
    this.cart.EcartTotalTaxAmount = this.EcartTotalTaxAmount;
    this.cart.EcartTotalCessAmount = this.EcartTotalCessAmount;
  }

  substractquantity(quantity, i) {
    this.quantityError = false;
    this.cartItems[i].Quantity = quantity - 1;
    this.cartItems[i].SubTotal = this.cartItems[i].Price * (quantity - 1);
    this.CalculateTotals();
    this.sendToCart();
  }

  addQuantity(quantity, i) {
    console.log(quantity);
    if (quantity + 1 > this.cartItems[i].MaxStockLimit) {
      this.quantityError = true;
      this.availableQuantity = this.cartItems[i].MaxStockLimit;
      this.cartItems[i].Quantity = this.cartItems[i].MaxStockLimit;
    } else {
      this.quantityError = false;
      this.cartItems[i].Quantity = quantity + 1;
      this.sendToCart();
    }
    this.cartItems[i].SubTotal =
      this.cartItems[i].Price * this.cartItems[i].Quantity;
    this.CalculateTotals();
  }
  onQuantityChange(quantity, i) {
    if (quantity > this.cartItems[i].MaxStockLimit) {
      this.quantityError = true;
      this.availableQuantity = this.cartItems[i].MaxStockLimit;
      this.cartItems[i].Quantity = this.cartItems[i].MaxStockLimit;
    } else {
      this.quantityError = false;
      this.cartItems[i].Quantity = quantity;
      this.sendToCart();
    }
    this.cartItems[i].SubTotal =
      this.cartItems[i].Price * this.cartItems[i].Quantity;
    this.CalculateTotals();
  }

  sendToCart() {
    this.cart.EcartItem = this.cartItems;
    localStorage.setItem("cart", JSON.stringify(this.cart));
    this.addToCartService.addToCartAfterCheckout();
  }

  removeFromCart(i) {
    this.quantityError = false;
    this.cartItems.splice(i, 1);
    this.cart.EcartItem = this.cartItems;
    localStorage.setItem("cart", JSON.stringify(this.cart));
    this.CalculateTotals();
    this.checkOutOfStockItems();
    this.addToCartService.removedFromCart();
    if (this.showErrorForSamsung == true) {
      window.location.reload()

    }
  }

  CheckOut() {
    // this.checkIfContainSamsung();
    console.log(this.cartItems);
    this.cart.EcartItem = this.cartItems;
    localStorage.setItem("cart", JSON.stringify(this.cart));
    if (localStorage.getItem("isLoggedin")) {
      console.log("x");
      if (this.down == false) {
        $("#now-modal").modal("show");
        return false;
      }
      this.addToCartService.addToCartAfterCheckout();
      if (this.ppavl == false) {
        this.router.navigate(["checkout"]);
      } else {
        this.router.navigate(["checkout"], {
          queryParams: { utm_source: "phonepe" },
        });

        // this.router.navigate(["checkout]",{utm_source=phonepe});
      }
    } else {
      if (this.ppavl == true) {
        PhonePe.PhonePe.build(PhonePe.Constants.Species.web).then((sdk) => {
          sdk
            .fetchAuthToken()
            .then((res) => {
              console.log(res);
              //   alert(res.grantToken)
              // console.log(JSON.stringify(res));
              // var str = '{"grantToken":"' + res.grantToken + '"}';
              // console.log(str);
              // var encodedData = window.btoa(str);
              // console.log(encodedData);
              // this.encodedBase64 = encodedData;
              // let shaObj = new jsSHA("SHA-256", "TEXT");
              // shaObj.update(
              //   encodedData +
              //   "/v3/service/auth/access" +
              //   "ee3c4a1c-a1b3-48c2-840a-b4b513b132d7"
              // );
              // let hash1 = shaObj.getHash("HEX");
              // var hash = hash1.toUpperCase();
              // console.log(hash1);
              // console.log(hash);

              this.fetchAccessToken(res.grantToken);
            })
            .catch((err) => {
              console.log(
                //{"error_code":"USER_SKIPPED","description":"User skipped"}
                "Error occurred while fetching the grant token: " + err
              );
              let error = JSON.parse(err);
              if (error.error_code == "USER_SKIPPED") {
                console.log(error.error_code);
                localStorage.setItem("isCartPage", "true");
                this.router.navigate(["login"], {
                  queryParams: { utm_source: "phonepe" },
                });
              }
              //  alert(err);
            });
        });
      } else {
        localStorage.setItem("isCartPage", "true");
        this.router.navigate(["login"]);
      }
    }
  }
  fetchAccessToken(base64body) {
    //  var xVerifyHeader = hash + "###" + 1;
    //  console.log(xVerifyHeader);
    var myobj = {
      request: base64body,
      XVERIFY: "test",
    };
    console.log(myobj);
    this.loaderService.display(true);
    this.http
      .post(this.baseUrl + "LoginAPI/PhonepeLoginAsync/", myobj)
      .subscribe(
        (data) => {
          this.response = data;
          console.log(this.response);

          this.loaderService.display(false);

          //   alert(this.response)
          // console.log(this.Response.data.accessToken);
          // let shaObj = new jsSHA("SHA-256", "TEXT");
          // shaObj.update(
          //   "/v3/service/userdetails" + "ee3c4a1c-a1b3-48c2-840a-b4b513b132d7"
          // );
          // let hash1 = shaObj.getHash("HEX");
          // var hash = hash1.toUpperCase();
          // console.log(hash1);
          // console.log(hash);
          // var xVerifyHeader = hash + "###" + 1;
          this.getUserDetails(this.response.data.accessToken);
        },
        (error: any) => {
          console.log(error);
          this.loaderService.display(false);
        }
      );
  }
  getUserDetails(accessToken) {
    var userDetailobj = {
      request: accessToken,
      XVERIFY: "test",
    };
    this.loaderService.display(true);

    this.http
      .post(this.baseUrl + "LoginAPI/GetUserDetails/", userDetailobj)
      .subscribe(
        (data) => {
          console.log(data);
          this.responseUserDetails = data;
          this.loaderService.display(false);
          //data.name,data.phoneNumber
          console.log(this.responseUserDetails);
          this.postUserDetails(this.responseUserDetails);
        },
        (error: any) => {
          console.log(error);
          this.loaderService.display(false);
        }
      );
  }
  postUserDetails(userdetails) {
    var postData = {
      MobileNumber: userdetails.data.phoneNumber,
      Name: userdetails.data.name,
      LoginType: "Phonepe",
      Email: userdetails.data.email != undefined ? userdetails.data.email : "",
    };
    console.log(postData);
    this.loaderService.display(true);

    this.http
      .post(this.baseUrl + "LoginAPI/PhonepeSilentLogin/", postData)
      .subscribe(
        (data) => {
          this.userDetails = data;
          this.loaderService.display(false);
          console.log(this.userDetails);
          if (this.userDetails.statusCode == 1) {
            console.log(this.userDetails);
            console.log(this.userDetails.mobileNumber);
            localStorage.setItem("customerId", this.userDetails.customerId);
            localStorage.setItem("customerName", this.userDetails.customerName);
            localStorage.setItem("isLoggedin", "true");
            localStorage.setItem(
              "customerMobile",
              this.userDetails.mobileNumber
            );

            console.log("login in now grocery via phone pe completed");
            if (this.down == false) {
              $("#now-modal").modal("show");
              return false;
            }
            this.addToCartService.addToCartAfterCheckout();
            this.router.navigate(["checkout"], {
              queryParams: { utm_source: "phonepe" },
            });
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  loadDataTopSelling() {
    this.service
      .get(this.baseUrl + "OfferAPI/GetTopSellingProductByStoreId")
      .subscribe(
        (data) => {
          console.log(data);
          this.products = data;
          for (var i = 0; i < this.products.length; i++) {
            for (var j = 0; j < this.topSellingStock.length; j++) {
              if (
                this.topSellingStock[j].productId == this.products[i].productId
              ) {
                this.products[i].totalStock = this.topSellingStock[
                  j
                ].totalStock;
                this.topSellingStock.splice(j, 1);
              }
            }
            i < 9
              ? this.products1.push(this.products[i])
              : this.products2.push(this.products[i]);
          }
          this.updateCart();
          this.showLoaderProduct = false;
        },
        (error) => {
          this.showLoaderProduct = false;
        }
      );
  }

  addToCart(product) {
    product.cartQuantity = 1;
    this.addToCartService.addToCart(product);
    this.checkOutOfStockItems();
    window.scrollTo(0, 0);
  }

  updateCart() {
    for (var i = 0; i < this.products.length; i++) {
      this.products[i].isAddedToCart = false;
    }
    for (var i = 0; i < this.cartItems.length; i++) {
      for (var j = 0; j < this.products.length; j++) {
        if (this.cartItems[i].ProductId == this.products[j].productId) {
          this.products[j].isAddedToCart = true;
          this.products[j].cartQuantity = this.cartItems[i].Quantity;
        }
      }
    }
  }

  substractquantityTopSelling(product, cartQuantity, i) {
    this.quantityError = false;
    product.cartQuantity = cartQuantity - 1;
    this.addToCartService.addToCart(product);
  }

  addQuantityTopSelling(product, cartQuantity, i) {
    if (cartQuantity + 1 > product.totalStock) {
      this.quantityError = true;
      this.availableQuantity = product.totalStock;
      product.cartQuantity = cartQuantity;
    } else {
      this.quantityError = false;
      product.cartQuantity = cartQuantity + 1;
    }
    this.addToCartService.addToCart(product);
    this.checkOutOfStockItems();
  }

  onQuantityChangeTopSelling(product, cartQuantity, i) {
    if (cartQuantity > product.totalStock) {
      this.quantityError = true;
      this.availableQuantity = product.totalStock;
      product.cartQuantity = product.totalStock;
    } else {
      this.quantityError = false;
      product.cartQuantity = cartQuantity;
    }
    this.addToCartService.addToCart(product);
    this.checkOutOfStockItems();
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/cart/cart.component.ts